import { Typography } from '@global-engineering-shared/gweb-material-ui';
import { CSSProperties } from 'react';

import StatusMessage from 'components/StatusMessage/StatusMessage';
import { MISSING_ELEMENT_TEXT } from 'components/Table/components/TableItem/components/TableListItem/components/TableListItemColumn/TableListItemColumn';
import { IColumn } from 'components/Table/types/Table';
import { State, Status } from 'features/Frames/types';
import { truncateText } from 'utils/truncateText';

import { stateFormatter } from './state';

const MAX_LENGTH = 70;
export const columns: IColumn[] = [
  {
    label: 'ID',
    value: 'id',
  },
  {
    label: 'FRAME NAME',
    value: 'name',
    columnContent: (name: string, isExpanded?: boolean) => (
      <Typography
        variant="body2"
        fontWeight={isExpanded ? 700 : 'inherit'}
        color={name === MISSING_ELEMENT_TEXT ? 'error' : 'textPrimary'}
      >
        {truncateText(name, MAX_LENGTH)}
      </Typography>
    ),
  },
  {
    label: 'FORMAT SIZE',
    value: 'formatSize',
  },
  {
    label: 'ENVIRONMENT',
    value: 'environment',
  },
  {
    label: 'PUBLISHER',
    value: 'publisher',
  },
  {
    label: 'SINCE',
    value: 'status',
    columnContent: (status: Status, isExpanded?: boolean) => (
      <StatusMessage status={status} isExpanded={isExpanded} />
    ),
    transform: (state: State) => stateFormatter(state),
    styles: { justifySelf: 'flex-end', paddingRight: '1rem' } as CSSProperties,
  },
];
